import { Component, inject, Inject } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { EMPTY, catchError, finalize, tap } from "rxjs";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { DialogHeaderComponent } from "../../../../shared/components/dialog-header/dialog-header.component";
import { EventsManagementService } from "@services/events-management.service";

export interface CancelEventDialogData {
  eventId: number;
  isFreeEvent?: boolean;
}

@Component({
  selector: "app-cancel-event-dialog",
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    DialogHeaderComponent,
    ButtonComponent,
  ],
  templateUrl: "./cancel-event-dialog.component.html",
  styleUrl: "./cancel-event-dialog.component.scss",
})
export class CancelEventDialogComponent {
  private readonly _eventsManagementService = inject(EventsManagementService);
  readonly dialogRef = inject(MatDialogRef<CancelEventDialogComponent>);

  eventId: number;
  isFreeEvent = false;
  loading = false;
  acceptedTerms = false;

  get canConfirm(): boolean {
    return this.isFreeEvent || this.acceptedTerms;
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: CancelEventDialogData) {
    this.eventId = data.eventId;
    this.isFreeEvent = !!data.isFreeEvent;
  }

  // TODO: confirmar com o BE se a justificativa será utilizada no cancelamento.
  // Enquanto o endpoint não recebe o motivo, o campo fica desativado.
  // justificativaCtrl = new FormControl("", Validators.required);

  confirm() {
    if (this.loading || !this.canConfirm) return;

    this.loading = true;
    this._eventsManagementService
      .cancelEvent(this.eventId)
      .pipe(
        tap(() => this.dialogRef.close(true)),
        catchError(() => EMPTY),
        finalize(() => (this.loading = false)),
      )
      .subscribe();
  }
}
